// extracted by mini-css-extract-plugin
export default {"customer":"CustomerBlock_customer__7637f","mobile":"CustomerBlock_mobile__l7Dcf","buttons":"CustomerBlock_buttons__mI-TL","buy":"CustomerBlock_buy__o8hCD"};